var _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef, memo } from "react";
var SvgHeart = function SvgHeart(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 46 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5427_10424",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 46,
    height: 40
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H45.5016V40H0V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5427_10424)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_5427_10424",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: 0,
    width: 47,
    height: 40
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.79551 6.44225C-1.89266 12.5385 0.70566 18.4723 3.97111 21.6217L23.0632 40L41.752 21.6875C44.7889 18.2996 45.9531 14.706 45.3064 10.7042C44.4133 5.16881 39.8669 0.874481 34.2506 0.261153C30.8064 -0.11106 27.4789 0.866769 24.8822 3.03218C24.1827 3.61466 23.5581 4.26604 23.0135 4.97396C22.3679 4.16784 21.61 3.43061 20.7533 2.77719C17.7671 0.500212 13.9657 -0.4041 10.314 0.299197C6.85585 0.96959 3.7518 3.20749 1.79551 6.44225Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_5427_10424)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.0078125 0.0657959H45.5455V40H-0.0078125V0.0657959Z",
    fill: "#FFA38D"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgHeart);
var Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDYiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0NiA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPG1hc2sgaWQ9Im1hc2swXzU0MjdfMTA0MjQiIHN0eWxlPSJtYXNrLXR5cGU6bHVtaW5hbmNlIiBtYXNrVW5pdHM9InVzZXJTcGFjZU9uVXNlIiB4PSIwIiB5PSIwIiB3aWR0aD0iNDYiIGhlaWdodD0iNDAiPgo8cGF0aCBkPSJNMCAwSDQ1LjUwMTZWNDBIMFYwWiIgZmlsbD0id2hpdGUiLz4KPC9tYXNrPgo8ZyBtYXNrPSJ1cmwoI21hc2swXzU0MjdfMTA0MjQpIj4KPG1hc2sgaWQ9Im1hc2sxXzU0MjdfMTA0MjQiIHN0eWxlPSJtYXNrLXR5cGU6bHVtaW5hbmNlIiBtYXNrVW5pdHM9InVzZXJTcGFjZU9uVXNlIiB4PSItMSIgeT0iMCIgd2lkdGg9IjQ3IiBoZWlnaHQ9IjQwIj4KPHBhdGggZD0iTTEuNzk1NTEgNi40NDIyNUMtMS44OTI2NiAxMi41Mzg1IDAuNzA1NjYgMTguNDcyMyAzLjk3MTExIDIxLjYyMTdMMjMuMDYzMiA0MEw0MS43NTIgMjEuNjg3NUM0NC43ODg5IDE4LjI5OTYgNDUuOTUzMSAxNC43MDYgNDUuMzA2NCAxMC43MDQyQzQ0LjQxMzMgNS4xNjg4MSAzOS44NjY5IDAuODc0NDgxIDM0LjI1MDYgMC4yNjExNTNDMzAuODA2NCAtMC4xMTEwNiAyNy40Nzg5IDAuODY2NzY5IDI0Ljg4MjIgMy4wMzIxOEMyNC4xODI3IDMuNjE0NjYgMjMuNTU4MSA0LjI2NjA0IDIzLjAxMzUgNC45NzM5NkMyMi4zNjc5IDQuMTY3ODQgMjEuNjEgMy40MzA2MSAyMC43NTMzIDIuNzc3MTlDMTcuNzY3MSAwLjUwMDIxMiAxMy45NjU3IC0wLjQwNDEgMTAuMzE0IDAuMjk5MTk3QzYuODU1ODUgMC45Njk1OSAzLjc1MTggMy4yMDc0OSAxLjc5NTUxIDYuNDQyMjVaIiBmaWxsPSJ3aGl0ZSIvPgo8L21hc2s+CjxnIG1hc2s9InVybCgjbWFzazFfNTQyN18xMDQyNCkiPgo8cGF0aCBkPSJNLTAuMDA3ODEyNSAwLjA2NTc5NTlINDUuNTQ1NVY0MEgtMC4wMDc4MTI1VjAuMDY1Nzk1OVoiIGZpbGw9IiNGRkEzOEQiLz4KPC9nPgo8L2c+Cjwvc3ZnPgo=";